<template>
    <div class="sound_trend_chart">
        <p v-if="hasTitle" class="homeComTitle hasLine">
            <span class="titleLine"></span>
            <span class="flex_1"> {{ title }}</span>
        </p>
        <section v-if="renderData && renderData.length" class="mt12 fs14 co_333">
            <div v-html="content"></div>
            <div class="chartBox mt28" :id='chartId'></div>
        </section>
        <img v-else class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
    </div>
</template>

<script>

let echarts = require('echarts');
import _ from "loadsh";

export default {
    name: 'renderDataChart',
    props: {
        renderData: Array,
        title: {
            type: String,
            default: '发文趋势'
        },
        content: String,
        hasTitle: Boolean,
        chartId: {
            type: String,
            default: 'soundTrendChart'
        }

    },
    data: function () {
        return {
            chart: null,
            negativePercent: 0,
        }
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    watch: {
        'renderData.total': function () {
            this.init();
        }
    },
    methods: {
        init: function () {
            if(!this.renderData || !this.renderData.length)
                return ;

            this.chart = echarts.init(document.getElementById(this.chartId));
            let xAxis = _.map(this.renderData, 'date');
            let yAxis = _.map(this.renderData, 'value');
            let option = {
                // backgroundColor: "#05224d",
                tooltip: {},
                grid: {
                    top: '13%',
                    left: '3%',
                    right: '9%',
                    bottom: '5%',
                    containLabel: true,
                },
                legend: {
                    data: ['报道量'],
                    right: 0,
                    itemWidth: 4,
                    paddind: 15,
                    icon: 'circle',
                    textStyle: {
                        color: "#023A9F",
                        fontSize: 10,
                    }
                },
                xAxis: [{
                    type: 'category',
                    // boundaryGap: false,
                    // axisLine: { //坐标轴轴线相关设置。数学上的x轴
                    //     show: true,
                    //     interval: 0,
                    //     lineStyle: {
                    //         fontSize: 10,
                    //         color: '#666666'
                    //     },
                    // },
                    // axisLabel: { //坐标轴刻度标签的相关设置
                    //     rotate: 0,
                    //     textStyle: {
                    //         fontSize: 10,
                    //         color: '#666666',
                    //     },
                    // },
                    // axisTick: {show: false},
                    data: xAxis,
                    axisLine: { //  改变x轴颜色
                        interval: 0,
                        lineStyle: {
                            type: [5, 10],
                            dashOffset: 5,
                            color: '#C9C9CA',
                        }
                    },
                    axisLabel: { //  改变x轴字体颜色和大小
                        textStyle: {
                            color: "#000000",
                            fontSize: 11
                        },
                        formatter: function(params) {
                            return params ? params.split(' ')[0] : '';
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false,
                    }
                }],
                yAxis: [{
                    type: 'value',
                    name: '传播(篇)',
                    nameTextStyle: {
                        color: '#666666',
                        fontWeight: 'bold',
                        align: "center",
                        fontSize: 10
                    },
                    min: 0,
                    // max:100,
                    splitNumber: 5,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['#C9C9CA'],
                            fontSize: 10,
                            width: 1,
                            type: 'dotted'
                        }
                    },
                    axisLine: {show: false,},
                    axisLabel: {
                        textStyle: {
                            fontSize: 10,
                            color: '#666666',

                        },
                    },
                    axisTick: {show: false,},
                }],
                series: [{
                    name: '报道量',
                    itemStyle: {
                        normal: {
                            color: "#6d9eff",
                            borderColor: "#6d9eff",
                            borderWidth: 2
                        }
                    },
                    type: 'line',
                    smooth: true, //是否平滑曲线显示
// 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
                    symbolSize: 0,

                    lineStyle: {
                        normal: {
                            color: "#013b9f"   // 线条颜色
                        }
                    },
                    areaStyle: { //区域填充样式
                        normal: {
                            //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {offset: 0, color: 'rgba(198,213,234, 0.4)'},
                                {offset: 0.7, color: 'rgba(198,213,234, 0)'}
                            ], false),

                            shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                            shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                        }
                    },
                    data: yAxis
                }]
            };
            this.chart.setOption(option);
        }
    },
}


</script>

<style lang="scss" scoped>
.sound_trend_chart {
    font-family: PingFangSC-Regular;

    .content {
        height: auto;
    }

    .content p {
        text-align: left;
    }


    .title {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.80);
        letter-spacing: 0;
        line-height: 20px;

        img {
            width: 16px;
            height: 16px;
            display: inline-block;
            margin-right: 4px;
            vertical-align: middle;
        }

    }

    .content {
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.85);
        letter-spacing: 0;
        line-height: 16px;
        margin-top: 8px;
    }

    .content span {
        color: #538DFF !important;
    }
}

.Sound-trend.changeStyle {
    padding: 0;

    .content {
        font-family: PingFangSC-Regular;
        line-height: 20px;
        font-size: 16px;
        margin-top: 0;
    }

    .content span {
        color: rgba(255, 255, 255, 0.8) !important;
    }

}
</style>
